import TourProductFactoryOptimize from '../Factory/TourProductFactoryOptimize';
import TourProductObjectValue from '../ObjectValue/TourProduct';

const TourProductsRepository = Backbone.Collection.extend({
    model: TourProductObjectValue,
    _isModel(model) {
        return model instanceof Backbone.Model || model instanceof TourProductFactoryOptimize;
    },
    getOnlyTourProducts() {
        return this.filter((tourProduct) => tourProduct.get('type') === 'TourProduct');
    },
});

export default TourProductsRepository;